// extracted by mini-css-extract-plugin
module.exports = {"rotate":"PopupContainer_rotate__T2kJ5","animation":"PopupContainer_animation__3riw2"};